import { registerLoaders } from '@loaders.gl/core';
import { ImageLoader } from '@loaders.gl/images';
import log from '../utils/log';
import { register } from '../debug';
import jsonLoader from '../utils/json-loader';
const version = typeof "8.8.27" !== 'undefined' ? "8.8.27" : globalThis.DECK_VERSION || 'untranspiled source';
const existingVersion = globalThis.deck && globalThis.deck.VERSION;

if (existingVersion && existingVersion !== version) {
  throw new Error("deck.gl - multiple versions detected: ".concat(existingVersion, " vs ").concat(version));
}

if (!existingVersion) {
  log.log(1, "deck.gl ".concat(version))();
  globalThis.deck = { ...globalThis.deck,
    VERSION: version,
    version,
    log,
    _registerLoggers: register
  };
  registerLoaders([jsonLoader, [ImageLoader, {
    imagebitmap: {
      premultiplyAlpha: 'none'
    }
  }]]);
}

export default globalThis.deck;
//# sourceMappingURL=init.js.map